import React, { useState, useCallback, useContext } from "react";
import styled from "styled-components";
import EditPic from "../../../SVGs/Edit.svg";
import CustomTextField from "../../Common/CustomTextField";
import CustomDropDown from "../../Common/CustomDropDown";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import toast from "react-hot-toast";
import { States } from "../../../utils/States";
import Cookies from "js-cookie";
import { UserContext } from "../../../Context/user_context";
import PageLoader from "../../Common/PageLoader";

function DriversLicense({ data, contactId, refetchData }) {
  const [isLoading, setIsLoading] = useState(false);
  const { user, setUser } = useContext(UserContext);

  const [driverLicense, setDriverLicense] = useState(false);
  const [number, setNumber] = useState(data ? data.new_driverslicense : "");
  const [state, setState] = useState(data ? data.new_driverslicensestate : "");
  const [issueDate, setIssueDate] = useState(data ? data.new_dlissuedate : "");
  const [expirationDate, setExpirationDate] = useState(
    data ? data.new_dlexpirationdate : ""
  );

  const handleDriversLicense = useCallback(() => {
    setDriverLicense(!driverLicense);
  }, [driverLicense]);

  const handleUpdateRecord = async () => {
    setIsLoading(true);
    const userid = contactId
      ? contactId
      : Cookies.get("hippocratic_portal_contactid");
    const recordData = {
      entity: "contacts",
      id: userid,
      attributes: [
        {
          fieldname: "new_driverslicense",
          value: number,
          type: "string",
          entity: null,
        },
        {
          fieldname: "new_driverslicensestate",
          value: state,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_dlissuedate",
          value: issueDate,
          type: "date",
          entity: null,
        },
        {
          fieldname: "new_dlexpirationdate",
          value: expirationDate,
          type: "date",
          entity: null,
        },
        ...(user.hip_initialportalinfoupdate ? [] : [{
          fieldname: "hip_initialportalinfoupdate",
          value: "910310000",
          type: "optionset",
          entity: null,
        }])
      ],
    };

    try {
      await getApiClient().updateRecord(recordData);
      if (!user.hip_initialportalinfoupdate) {
        setUser({
          ...user,
          hip_initialportalinfoupdate: true
        });
      }
      toast.success("Information has been updated succesfully");
      // Refetch data to get updated information
      if (refetchData) {
        await refetchData();
      }
    } catch (error) {
      makeStandardApiErrorHandler((error) => toast.error(error));
    } finally {
      setDriverLicense(!driverLicense);
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Sectoin>
        <TopPart>
          <SubTitle>Driver License</SubTitle>
          {driverLicense ? (
            <Save onClick={handleUpdateRecord}>Save Changes</Save>
          ) : (
            <Edit
              onClick={() => {
                handleDriversLicense();
              }}
            >
              Edit
              <img style={{ height: "19px" }} src={EditPic} alt="edit-icon" />
            </Edit>
          )}
        </TopPart>
        <BottomPart>
          <FieldsContainer>
            <CustomTextField
              Active={driverLicense}
              Title="#:"
              value={number}
              onChange={setNumber}
            />
            <CustomDropDown
              Active={driverLicense}
              options={States}
              Title="State:"
              value={state}
              onChange={setState}
            />
          </FieldsContainer>
          <FieldsContainer>
            <CustomTextField
              Active={driverLicense}
              Title="Issue Date:"
              Type={"date"}
              value={issueDate}
              onChange={setIssueDate}
            />
            <CustomTextField
              Active={driverLicense}
              Title="Expiration Date:"
              Type={"date"}
              value={expirationDate}
              onChange={setExpirationDate}
            />
          </FieldsContainer>
          <FieldsContainer></FieldsContainer>
        </BottomPart>
      </Sectoin>
    </>
  );
}

const Sectoin = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
`;

const TopPart = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

const Edit = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #87a9bf;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
  line-height: 10px;
  text-decoration-line: underline;
`;

const BottomPart = styled.div`
  display: grid;
  min-height: 100px;
  gap: 30px;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-items: center;

  @media screen and (max-width: 450px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`;
const SubTitle = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const FieldsContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

const Save = styled.div`
  border-radius: 300px;
  background: #304961;
  padding: 5px 10px;

  cursor: pointer;

  white-space: nowrap;

  color: #fff;
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`;

export default DriversLicense;
